import request from "@/utils/request";

export function GetAllBranches() {
  return request({
    url: "/Branch/GetAllBranches",
    method: "post",
  });
}

export function SaveBranch(
  id,
  schoolid,
  name,
  active,
  terminalId,
  reserveBeforeWeekend,
  automaticJarimeh
) {
  return request({
    url: "/Branch/Save",
    method: "post",
    data: {
      Id: id,
      Name: name,
      Schoolid: schoolid,
      Active: active,
      TerminalId: terminalId,
      ReserveBeforeWeekend: reserveBeforeWeekend,
      AutomaticJarimeh: automaticJarimeh,
    },
  });
}

export function GetBranchUsers(id) {
  return request({
    url: "/Branch/GetBranchUsers",
    method: "post",
    data: {
      Id: id,
    },
  });
}
export function GetBranchReport(startDate, endDate) {
  return request({
    url: "/Branch/GetBranchReport",
    method: "post",
    data: {
      StartTarikh: startDate,
      EndTarikh: endDate,
    },
  });
}

export function GetBranchInfo(id) {
  return request({
    url: "/Branch/GetBranchInfo",
    method: "post",
    data: {
      Id: id,
    },
  });
}

export function GetBranchNames() {
  return request({
    url: "/Branch/GetUserBranchesNames",
    method: "post",
  });
}
